var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 17.1542V7.35559C25.8333 6.64259 25.2547 6.06392 24.5417 6.06392H6.45834C5.74534 6.06392 5.16667 6.64259 5.16667 7.35559V25.4389C5.16667 25.993 5.51542 26.4658 6.00496 26.6492L19.7535 12.9007C20.2585 12.3957 21.0761 12.3957 21.5799 12.9007L25.8333 17.1542ZM25.8333 20.807L20.6667 15.6403L9.57642 26.7306H24.5417C25.2547 26.7306 25.8333 26.1519 25.8333 25.4389V20.807ZM6.45834 3.48059H24.5417C26.682 3.48059 28.4167 5.2153 28.4167 7.35559V25.4389C28.4167 27.5792 26.682 29.3139 24.5417 29.3139H6.45834C4.31804 29.3139 2.58334 27.5792 2.58334 25.4389V7.35559C2.58334 5.2153 4.31804 3.48059 6.45834 3.48059ZM10.9792 15.1056C9.19538 15.1056 7.75 13.6602 7.75 11.8764C7.75 10.0926 9.19538 8.64726 10.9792 8.64726C12.763 8.64726 14.2083 10.0926 14.2083 11.8764C14.2083 13.6602 12.763 15.1056 10.9792 15.1056ZM10.9792 12.5223C11.3357 12.5223 11.625 12.2329 11.625 11.8764C11.625 11.5199 11.3357 11.2306 10.9792 11.2306C10.6227 11.2306 10.3333 11.5199 10.3333 11.8764C10.3333 12.2329 10.6227 12.5223 10.9792 12.5223Z",
    fill: "#2C3439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.296da9ad5de7ae804c410d4c97207884.svg";
export { ForwardRef as ReactComponent };